import {normalize} from 'normalizr';
import {receiveEntities} from '../entities';
import {tournamentSchema} from '../../schemas/tournament';

import {getEndpoint, getHeaders} from '../../helpers/endpoint';

export const REQUEST_FETCH_TOURNAMENT = 'REQUEST_FETCH_TOURNAMENT';
export const SUCCESS_FETCH_TOURNAMENT = 'SUCCESS_FETCH_TOURNAMENT';
export const FAIL_FETCH_TOURNAMENT = 'FAIL_FETCH_TOURNAMENT';

export const fetchTournament = (tournamentId, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_TOURNAMENT, tournamentId, scope});

    fetch(getEndpoint('fetchTournament', tournamentId), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_TOURNAMENT,
            error: data.error,
            tournamentId,
            scope,
          });
        else dispatch(successFetchTournament(data, tournamentId, scope));
      })
      .catch((error, type = FAIL_FETCH_TOURNAMENT) => {
        dispatch({type, error, tournamentId, scope});
      });
  };
};

function successFetchTournament(response, tournamentId, scope) {
  return dispatch => {
    const normalized = normalize(response.tournament, tournamentSchema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_TOURNAMENT,
      receivedAt: Date.now(),
      id: normalized.result,
      tournamentId,
      scope,
    });
  };
}

export const REQUEST_UPDATE_TOURNAMENT_NAME = 'REQUEST_UPDATE_TOURNAMENT_NAME';
export const SUCCESS_UPDATE_TOURNAMENT_NAME = 'SUCCESS_UPDATE_TOURNAMENT_NAME';
export const FAIL_UPDATE_TOURNAMENT_NAME = 'FAIL_UPDATE_TOURNAMENT_NAME';

export const updateTournamentName = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_TOURNAMENT_NAME, payload, scope});

    fetch(getEndpoint('updateTournamentName', payload.tournamentId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({name: String(payload.name)}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: SUCCESS_UPDATE_TOURNAMENT_NAME,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdateTournamentName(data, payload, scope));
      })
      .catch((error, type = SUCCESS_UPDATE_TOURNAMENT_NAME) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateTournamentName(response, payload, scope) {
  return {
    type: SUCCESS_UPDATE_TOURNAMENT_NAME,
    receivedAt: Date.now(),
    success: response.success,
    payload,
    scope,
  };
}

export const REQUEST_UPDATE_TOURNAMENT_IS_PUBLIC =
  'REQUEST_UPDATE_TOURNAMENT_IS_PUBLIC';
export const SUCCESS_UPDATE_TOURNAMENT_IS_PUBLIC =
  'SUCCESS_UPDATE_TOURNAMENT_IS_PUBLIC';
export const FAIL_UPDATE_TOURNAMENT_IS_PUBLIC =
  'FAIL_UPDATE_TOURNAMENT_IS_PUBLIC';

export const updateTournamentIsPublic = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_UPDATE_TOURNAMENT_IS_PUBLIC, payload, scope});

    fetch(getEndpoint('updateTournamentIsPublic', payload.tournamentId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({isPublic: Boolean(payload.isPublic)}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_UPDATE_TOURNAMENT_IS_PUBLIC,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successUpdateTournamentIsPublic(data, payload, scope));
      })
      .catch((error, type = FAIL_UPDATE_TOURNAMENT_IS_PUBLIC) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successUpdateTournamentIsPublic(response, payload, scope) {
  return {
    type: SUCCESS_UPDATE_TOURNAMENT_IS_PUBLIC,
    receivedAt: Date.now(),
    success: response.password,
    payload,
    scope,
  };
}



// WEBPACK FOOTER //
// ./src/actions/entities/tournament.js